// Shared HTML-escaping helper for safe interpolation of untrusted strings
// (filenames, tool/agent names, server-sourced labels) into innerHTML templates.
//
// Escapes & < > " ' so the result is safe in both text and attribute contexts and
// renders identically to the raw string in text. For full markdown/HTML bodies use
// DOMPurify.sanitize(marked.parse(...)) instead (see ui.js renderMarkdown).
const _HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

export function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    return String(text).replace(/[&<>"']/g, (c) => _HTML_ESCAPES[c]);
}
